const insertWidget = ({ state, type, data }) => {
  return state
    .transform()
    .insertBlock({
      type,
      isVoid: true,
      data
    })
    .apply()
}

const updateWidget = ({ state, type, data }) => {
  return state
    .transform()
    .setBlock({
      type,
      isVoid: true,
      data
    })
    .apply()
}

const removeWidget = ({ state, key }) => {
  return state
    .transform()
    .removeNodeByKey(key)
    .apply()
}

export {
  insertWidget,
  updateWidget,
  removeWidget
}



// WEBPACK FOOTER //
// ./src/components/WidgetSlatePlugin/WidgetUtils.js